import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
// core components
import * as actionCreators from "actions/auth";
import Footer from "components/FooterMainPage/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Danger from "components/Typography/Danger";

import resetPassPageStyle from "assets/jss/material-kit-react/views/resetPassPage.jsx";

import image from "assets/img/bg7.jpg";

function mapStateToProps(state) {
    return {
        statusText: state.auth.statusText,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class ResetPassPage extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        const redirectRoute = "/login";
        this.state = {
            cardAnimaton: "cardHidden",
            email: "",
            redirectTo: redirectRoute,
        };
    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    _handleKeyPress(e){
        if (e.key === "Enter" ){
            this.reset_pass(e)
        }
    }

    reset_pass(e){
        e.preventDefault();
        this.state.email && this.props.resetUserPass(this.state.email);
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function() {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    render() {
        const { classes, statusText, isAuthenticated } = this.props;
        return (
            isAuthenticated ?
                <Redirect to="/" push={true}/> :
                <div onKeyPress={(e) => this._handleKeyPress(e)}>
                    <div
                        className={classes.pageHeader}
                        style={{
                            backgroundImage: "url(" + image + ")",
                            backgroundSize: "cover",
                            backgroundPosition: "top center"
                        }}
                    >
                        <div className={classes.container}>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={4}>
                                    <Card className={classes[this.state.cardAnimaton]}>
                                        <form className={classes.form}>
                                            <CardHeader color="info" className={classes.cardHeader}>
                                                <h3>Сброс пароля</h3>

                                            </CardHeader>
                                            <CardBody>
                                                <Link to="/">
                                                    <Button simple color="info" size="lg" className={classes.buttonBackward}>
                                                        <KeyboardArrowLeft/> Назад
                                                    </Button>
                                                </Link>
                                                { statusText &&
                                                <Danger>{statusText}</Danger>
                                                }
                                                <CustomInput
                                                    labelText="email"
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        type: "email",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Email className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        ),
                                                        onChange:(e) => this.changeValue(e, "email")
                                                    }}
                                                />

                                            </CardBody>
                                            <CardFooter className={classes.cardFooter}>
                                                <Button simple color="info" size="lg" onClick={(e) => this.reset_pass(e)}>
                                                    Сбросить
                                                </Button>
                                            </CardFooter>
                                        </form>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </div>
                        <Footer whiteFont />
                    </div>
                </div>
        );
    }
}

ResetPassPage.propTypes = {
    resetUserPass: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(resetPassPageStyle)(ResetPassPage));



// WEBPACK FOOTER //
// ./src/views/ResetPass/ResetPass.jsx